var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "container-fluid py-40 py-md-56 py-lg-80 bg-accent d-flex align-items-center"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "container d-flex flex-column flex-md-row align-items-start align-items-md-center"
          },
          [
            _c(
              "h3",
              { staticClass: "text-white d-inline-block mb-16 mb-md-0 mr-56" },
              [_vm._v(_vm._s(_vm.text))]
            ),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "btn btn-white", attrs: { href: _vm.href } },
              [
                _vm._v(_vm._s(_vm.btn) + " "),
                _c("span", {
                  staticClass: "arrow-right",
                  domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                })
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }